import type { AgentChatMessageApi } from '@/api/client';
import type { TrackerChatMessage } from '@/components/Messenger/types/chatMessageTypes';
import { coalesceAssistantMessageFromSources } from '@/components/Messenger/agent/assistantChatMessageMetadata';
import { mapAgentApiMessageToUiMessage } from '@/components/Messenger/agent/agentChatMessageMap';
import { mergeStableTrackerChatMessages } from '@/components/Messenger/agent/agentChatMessageStability';

/**
 * Вносит строки из socket patch (канонический API-формат) в текущий список `useChat`,
 * сохраняя порядок и переиспользуя ссылки на неизменённые сообщения.
 * Мета ассистента — через тот же {@link coalesceAssistantMessageFromSources}, что и стабильный мерж.
 */
export function mergeTrackerMessagesWithSocketPatchRows(
  prev: TrackerChatMessage[],
  apiRows: AgentChatMessageApi[]
): TrackerChatMessage[] {
  if (!apiRows.length) return prev;
  const incomingUi = apiRows.map(mapAgentApiMessageToUiMessage);
  const indexById = new Map(prev.map((m, i) => [m.id, i] as const));
  const next = [...prev];
  for (const row of incomingUi) {
    const idx = indexById.get(row.id);
    if (idx !== undefined) {
      const prevRow = next[idx];
      next[idx] =
        prevRow && prevRow.id === row.id
          ? coalesceAssistantMessageFromSources(prevRow, row)
          : row;
    } else {
      next.push(row);
      indexById.set(row.id, next.length - 1);
    }
  }
  return mergeStableTrackerChatMessages(prev, next);
}
